import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_item = _resolveComponent("ion-item")!

  return (_openBlock(), _createBlock(_component_ion_item, {
    class: "select-quarter",
    lines: "none"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_select, {
        modelValue: _ctx.selected,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected) = $event)),
        interface: "popover",
        "interface-options": { cssClass: 'trade-popover' },
        onIonChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeQuarter()))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trades, (trade, index) => {
            return (_openBlock(), _createBlock(_component_ion_select_option, {
              key: index,
              value: index,
              disabled: index == _ctx.selected
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(trade.period), 1)
              ]),
              _: 2
            }, 1032, ["value", "disabled"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}